<h2
  *ngIf="modal.currentDatas.titleRef"
  [innerHtml]="modal.currentDatas.titleRef | translate: modal.currentDatas.titleArgs"></h2>
<p
  *ngIf="modal.currentDatas.contentRef"
  [innerHtml]="modal.currentDatas.contentRef | translate: modal.currentDatas.contentArgs"></p>
<div class="message-actions">
  <ng-casto-button
    *ngFor="let button of modal.currentDatas.buttons"
    [class.primary]="button.primary"
    [class.secondary]="!button.primary"
    (click)="button.action()"
    [label]="button.labelRef ? (button.labelRef | translate) : button.label"></ng-casto-button>
</div>
